// Normalise the admin-service DTO into the view model the rest of the
// module consumes. Responsibilities:
//   1. Stringify the id so call sites never have to guard `number | string`.
//   2. Pin defaults for role / status / invitation / access so the rest of
//      the app can rely on non-null values for every column we render.
//   3. Translate the audit-event DTO into the view-model shape.

import type { AdminAuditDto, AdminAuditEventDto, AdminDto } from './adminContracts'
import type { Admin, AdminAuditEvent } from '../types/adminTypes'

export const parseAdmin = (dto: AdminDto): Admin => ({
  id: String(dto.id ?? ''),
  name: dto.name ?? '',
  email: dto.email ?? '',
  role: dto.role ?? 'User Manager',
  status: dto.status ?? 'Active',
  invitationStatus: dto.invitationStatus ?? 'accepted',
  accessScope: dto.accessScope ?? 'Reports read-only',
  mfaEnabled: dto.mfaEnabled ?? false,
  lastLoginAt: dto.lastLoginAt ?? null,
  createdBy: dto.createdBy ?? 'System',
  createdAt: dto.createdAt ?? null,
  lastPermissionChangeAt: dto.lastPermissionChangeAt ?? null,
})

export const parseAdminAuditEvent = (dto: AdminAuditEventDto): AdminAuditEvent => ({
  id: dto.id ?? '',
  at: dto.at ?? '',
  actor: dto.actor ?? 'System',
  event: dto.event ?? '',
  detail: dto.detail ?? '',
})

export const parseAdminAudit = (dto: AdminAuditDto): AdminAuditEvent[] =>
  (dto.events ?? []).map(parseAdminAuditEvent)
